import type { DesignTokens } from "../types/theme";

const WEB_SYSTEM_FONT =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

/**
 * Base tokens for Light mode.
 */
export const LIGHT_BASE_TOKENS: DesignTokens = {
  background: "#f4f6f9",
  foreground: "#1e293b",
  surface: "#ffffff",
  surfaceForeground: "#1e293b",
  surfaceSecondary: "#eef1f5",
  surfaceSecondaryForeground: "#1e293b",
  surfaceTertiary: "#e3e8ee",
  surfaceTertiaryForeground: "#1e293b",
  overlay: "#ffffff",
  overlayForeground: "#1e293b",
  muted: "#64748b",
  default: "#eef1f5",
  defaultForeground: "#1e293b",
  accent: "#0c8fb8",
  accentForeground: "#f8fafc",
  danger: "#e23c54",
  dangerForeground: "#f8fafc",
  warning: "#f59e0b",
  warningForeground: "#1e293b",
  success: "#10a87f",
  successForeground: "#1e293b",
  separator: "#b3bdc9",
  glassBackground: "rgba(255, 255, 255, 0.72)",
  glassBorder: "rgba(30, 41, 59, 0.1)",
  glassHighlight: "rgba(30, 41, 59, 0.07)",
  glow0: "rgba(12, 143, 184, 0.12)",
  glow1: "rgba(16, 168, 127, 0.09)",
  glow2: "rgba(71, 110, 168, 0.07)",
  mutedForeground: "#1e293b",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(30, 41, 59, 0.1)",
  overlayShadow: "rgba(30, 41, 59, 0.14)",
  fieldShadow: "rgba(30, 41, 59, 0.06)",
  fieldBorder: "rgba(30, 41, 59, 0.12)",
  fieldPlaceholder: "rgba(30, 41, 59, 0.45)",
  fieldBackground: "rgba(30, 41, 59, 0.04)",
  segment: "#ffffff",
  segmentForeground: "#1e293b",
  link: "#0c8fb8",
  focus: "#0c8fb8",
  fieldForeground: "#1e293b",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#b3bdc9",
  primary: "#0c8fb8",
  primaryForeground: "#f8fafc",
  secondary: "#eef1f5",
  secondaryForeground: "#1e293b",
  backdrop: "rgba(8, 12, 20, 0.5)",
};

/**
 * Base tokens for Dark mode.
 */
export const DARK_BASE_TOKENS: DesignTokens = {
  background: "#0f1623",
  foreground: "#f8fafc",
  surface: "#1c2636",
  surfaceForeground: "#f8fafc",
  surfaceSecondary: "#232f42",
  surfaceSecondaryForeground: "#f8fafc",
  surfaceTertiary: "#2c3a50",
  surfaceTertiaryForeground: "#f8fafc",
  overlay: "#202b3c",
  overlayForeground: "#f8fafc",
  muted: "#94a3b8",
  default: "#283448",
  defaultForeground: "#f8fafc",
  accent: "#3fb0d4",
  accentForeground: "#0f1623",
  danger: "#ef4d63",
  dangerForeground: "#f8fafc",
  warning: "#fbbf24",
  warningForeground: "#1e293b",
  success: "#2fb78d",
  successForeground: "#0f1623",
  separator: "#3a485e",
  glassBackground: "rgba(28, 38, 54, 0.55)",
  glassBorder: "rgba(255, 255, 255, 0.12)",
  glassHighlight: "rgba(255, 255, 255, 0.22)",
  glow0: "rgba(63, 176, 212, 0.42)",
  glow1: "rgba(47, 183, 141, 0.34)",
  glow2: "rgba(86, 130, 200, 0.3)",
  mutedForeground: "#f8fafc",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.32)",
  overlayShadow: "rgba(0, 0, 0, 0.5)",
  fieldShadow: "rgba(0, 0, 0, 0.25)",
  fieldBorder: "rgba(255, 255, 255, 0.11)",
  fieldPlaceholder: "rgba(255, 255, 255, 0.42)",
  fieldBackground: "rgba(255, 255, 255, 0.04)",
  segment: "#384866",
  segmentForeground: "#f8fafc",
  link: "#3fb0d4",
  focus: "#3fb0d4",
  fieldForeground: "#f8fafc",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#3a485e",
  primary: "#3fb0d4",
  primaryForeground: "#0f1623",
  secondary: "#283448",
  secondaryForeground: "#f8fafc",
  backdrop: "rgba(0, 0, 0, 0.7)",
};
